export const ExchangeConfig: Config = {
  CHANGE: 'CHANGE',
  RETURN: 'RETURN',
  STORE_WITHDRAWAL: 'STORE_WITHDRAWAL',
  HOME_DELIVERY: 'HOME_DELIVERY',
  DISPATCH_TYPES: [
    { CHANGE: 'CHANGE' },
    { RETURN: 'RETURN' }
  ],
  DELIVERY_TYPES: [
    { id: 'STORE_WITHDRAWAL', value: 'Retiro en tienda' },
    { id: 'HOME_DELIVERY', value: 'Despacho a domicilio' }
  ],
  RETURN_TYPES: [
    { id: 'STORE_WITHDRAWAL', value: 'Devolución en tienda' },
    { id: 'HOME_DELIVERY', value: 'Recojo a domicilio' }
  ],
  PRODUCT_TYPE:
    {
      /**
       * ST = Producto de venta
       */
      ST: 'ST',
      /**
       * SV = Servicio adicional
       */
      SV: 'SV',
      /**
       * FL = Flete
       */
      FL: 'FL'
    }
};

interface Config {
  CHANGE: string;
  RETURN: string;
  STORE_WITHDRAWAL: string;
  HOME_DELIVERY: string;
  DISPATCH_TYPES: any[];
  DELIVERY_TYPES: any[];
  RETURN_TYPES: any[];
  PRODUCT_TYPE?: any;
}

